<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <div class="Info_Area">
      <b-container fluid>
        <b-row align-h="between">
          <b-col cols="10">
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="calendar3"></b-icon>
              </b-input-group-prepend>
              <datepicker
                v-model="date"
                style="max-width: fit-content;"
                min="1960-01-01"
                :max="maxdate"
              ></datepicker>
            </b-input-group>
            <!-- <b-form-datepicker
                            :date-disabled-fn="dateDisabled"
                            :max="maxdate"
                            size="sm"
                            v-model="date"
                            @context="datechange">
                        </b-form-datepicker> -->
            <!-- <b-row> -->
            <!-- <b-col cols="1.5">
                                <span>日期</span>
                            </b-col> -->
            <!-- <b-col>
                                <b-form-input v-model="date" type="text" disabled style="width:150px"></b-form-input>
                            </b-col> -->
            <!-- </b-row> -->
          </b-col>
          <b-col cols="auto">
            <!-- <b-button @click="$bvModal.show('addCropModal')" variant="warning">新增品項</b-button> -->
            <!-- <v-select id="marketselect" v-model="fruit.selected" :options="pasrseToOptions(cropcodelist)" style="width:200px;"></v-select>
                    </b-col>
                    <b-col>
                        <b-button @click="addProcess" variant="warning">新增品項</b-button>
                    </b-col>
                    <b-col> -->
            <b-button @click="modalshow = !modalshow" variant="warning"
              >新增品項</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col style="height:30px;"></b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <!-- <b-table
                            :items="priceanalysis.items"
                            :fields="priceanalysis.fields"
                            :busy="isBusy"
                            :sort-by.sync="sortBy"
                            responsive="sm"
                            striped
                            bordered
                            outlined
                            hover
                            >
                            <template #table-busy>
                                <div class="text-center my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template #thead-top head-variant="dark">
                                <b-tr class="thead-dark">
                                    <b-th rowspan="2">日期</b-th> -->
            <!-- <b-th rowspan="2">品項</b-th> -->
            <!-- <b-th colspan="3">批發交易行情 (元/公斤)</b-th> -->
            <!-- <b-th colspan="3">嘉義縣產地價 (元/公斤)</b-th>
                                    <b-th rowspan="2">農糧署產地價格監控 (元/公斤)</b-th>
                                    <b-th rowspan="2">詢問單位</b-th>
                                    <b-th rowspan="2">備註及說明</b-th>
                                    <b-th rowspan="2">操作</b-th>
                                </b-tr>
                                <b-tr class="thead-dark"> -->
            <!-- <b-th>上價</b-th>
                                    <b-th>中價</b-th>
                                    <b-th>下價</b-th> -->
            <!-- <b-th>上價</b-th>
                                    <b-th>中價</b-th>
                                    <b-th>下價</b-th>
                                </b-tr>
                            </template>
                            <template #cell(CM_CODE)="data">
                                {{getName(data.item.CM_CODE)}}
                            </template>
                            <template #cell(CM_PRICE_C)="data">
                                <b-form-input v-model="data.item.CM_PRICE_C"  type="text"></b-form-input>
                            </template>
                            <template #cell(CM_PRICE_M)="data">
                                <b-form-input v-model="data.item.CM_PRICE_M"  type="text"></b-form-input>
                            </template>
                            <template #cell(CM_PRICE_F)="data">
                                <b-form-input v-model="data.item.CM_PRICE_F"  type="text"></b-form-input>
                            </template>
                            <template #cell(CM_PRICE_MON)="data">
                                <b-form-input v-model="data.item.CM_PRICE_MON"  type="text"></b-form-input>
                            </template>
                            <template #cell(CM_QUEST)="data">
                                <b-form-textarea v-model="data.item.CM_QUEST" rows="3"></b-form-textarea>
                            </template>
                            <template #cell(CM_NOTES)="data">
                                <b-form-textarea v-model="data.item.CM_NOTES" rows="3"></b-form-textarea>
                            </template>
                            <template #cell(EDIT)="data"> -->
            <!-- <b-button variant="success">儲存</b-button> -->
            <!-- <b-button @click="removeProcess(data.item.CM_CODE)" variant="danger">刪除</b-button> -->
            <!-- </template> -->
            <!-- </b-table> -->
            <b-table-simple>
              <b-thead head-variant="dark">
                <b-tr class="thead-dark">
                  <!-- <b-th rowspan="2">日期</b-th> -->
                  <b-th rowspan="2">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="ifSorting"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                      >排序
                    </b-form-checkbox>
                  </b-th>
                  <b-th rowspan="2">品項</b-th>
                  <!-- <b-th rowspan="2">規格</b-th> -->
                  <template v-if="window.width >= 650">
                    <b-th colspan="3">嘉義縣產地價 (元/公斤)</b-th>
                    <b-th v-if="datamanagement.maintain_show || datamanagement.maintain_edit" rowspan="2">農糧署產地價格監控 (元/公斤)</b-th>
                    <b-th rowspan="2">詢問單位</b-th>
                    <b-th rowspan="2">備註及說明</b-th>
                  </template>
                  <b-th v-if="ifshowdelete" rowspan="2">操作</b-th>
                </b-tr>
                <b-tr v-if="window.width >= 650" class="thead-dark">
                  <!-- <b-th>上價</b-th>
                                    <b-th>中價</b-th>
                                    <b-th>下價</b-th> -->
                  <b-th>上價</b-th>
                  <b-th>中價</b-th>
                  <b-th>下價</b-th>
                </b-tr>
              </b-thead>
              <template v-if="!ifSorting">
                <b-tbody>
                  <template v-for="(item, index) in priceanalysis.items">
                    <b-tr :key="index">
                      <b-td>
                        {{ item.CM_SORT }}
                      </b-td>
                      <b-td>
                        {{ getName(item.CM_CODE) }}
                      </b-td>
                      <!-- <b-td>
                        {{ item.CROP_SPEC }}
                      </b-td> -->
                      <template v-if="window.width >= 650">
                        <b-td>
                          <b-form-input
                            v-model="item.CM_PRICE_C"
                            type="text"
                          ></b-form-input>
                        </b-td>
                        <b-td>
                          <b-form-input
                            v-model="item.CM_PRICE_M"
                            type="text"
                          ></b-form-input>
                        </b-td>
                        <b-td>
                          <b-form-input
                            v-model="item.CM_PRICE_F"
                            type="text"
                          ></b-form-input>
                        </b-td>
                        <template v-if="datamanagement.maintain_edit">
                          <b-td>
                            <b-form-input
                              v-model="item.CM_PRICE_MON"
                              type="text"
                            ></b-form-input>
                          </b-td>
                        </template>
                        <template v-else-if="datamanagement.maintain_show">
                          <b-td>
                            {{item.CM_PRICE_MON}}
                          </b-td>
                        </template>
                        <b-td>
                          <b-form-textarea
                            v-model="item.CM_QUEST"
                            rows="3"
                          ></b-form-textarea>
                        </b-td>
                        <b-td>
                          <b-form-textarea
                            v-model="item.CM_NOTES"
                            rows="3"
                          ></b-form-textarea>
                        </b-td>
                      </template>
                      <b-td>
                        <b-button
                          v-if="window.width < 650"
                          @click="item.ifshow = !item.ifshow"
                          style="margin-bottom: 0.3rem;"
                          variant="success"
                          >{{ item.ifshow ? "隱藏" : "詳細" }}</b-button
                        >
                        <b-button
                          v-if="ifshowdelete"
                          @click="removeProcess(item)"
                          variant="danger"
                          >刪除</b-button
                        >
                      </b-td>
                    </b-tr>
                    <b-tr v-if="item.ifshow" :key="'detial' + index">
                      <b-td colspan="9">
                        <b-card>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>嘉義縣產地價上價:</b></b-col
                            >
                            <b-col
                              ><b-form-input
                                v-model="item.CM_PRICE_C"
                                type="text"
                              ></b-form-input
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>嘉義縣產地價中價:</b></b-col
                            >
                            <b-col
                              ><b-form-input
                                v-model="item.CM_PRICE_M"
                                type="text"
                              ></b-form-input
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>嘉義縣產地價下價:</b></b-col
                            >
                            <b-col
                              ><b-form-input
                                v-model="item.CM_PRICE_F"
                                type="text"
                              ></b-form-input
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>農糧署產地價格監控 (元/公斤):</b></b-col
                            >
                            <b-col
                              ><b-form-input
                                v-model="item.CM_PRICE_MON"
                                type="text"
                              ></b-form-input
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>詢問單位:</b></b-col
                            >
                            <b-col
                              ><b-form-textarea
                                v-model="item.CM_QUEST"
                                rows="3"
                              ></b-form-textarea
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-col sm="3" class="text-sm-right"
                              ><b>備註及說明:</b></b-col
                            >
                            <b-col
                              ><b-form-textarea
                                v-model="item.CM_NOTES"
                                rows="3"
                              ></b-form-textarea
                            ></b-col>
                          </b-row>
                          <b-row class="mb-2">
                            <b-button
                              variant="success"
                              @click="item.ifshow = !item.ifshow"
                              >確定</b-button
                            >
                          </b-row>
                        </b-card>
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
              <template v-else-if="ifSorting">
                <draggable
                  tag="tbody"
                  v-model="priceanalysis.items"
                  force-fallback="true"
                  animation="1000"
                  @end="onEnd"
                >
                  <b-tr
                    v-for="(item, index) in priceanalysis.items"
                    :key="index"
                  >
                    <b-td>
                      {{ item.CM_SORT }}
                    </b-td>
                    <b-td>
                      {{ getName(item.CM_CODE) }}
                    </b-td>
                    <!-- <b-td>
                      {{ item.CROP_SPEC }}
                    </b-td> -->
                    <b-td>
                      {{ item.CM_PRICE_C }}
                    </b-td>
                    <b-td>
                      {{ item.CM_PRICE_M }}
                    </b-td>
                    <b-td>
                      {{ item.CM_PRICE_F }}
                    </b-td>
                    <b-td>
                      {{ item.CM_PRICE_MON }}
                    </b-td>
                    <b-td>
                      {{ item.CM_QUEST }}
                    </b-td>
                    <b-td>
                      {{ item.CM_NOTES }}
                    </b-td>
                    <b-td>
                      <b-button @click="removeProcess(item)" variant="danger"
                        >刪除</b-button
                      >
                    </b-td>
                  </b-tr>
                </draggable>
              </template>
            </b-table-simple>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col>
            <b-button @click="getToken" variant="warning">儲存</b-button>
          </b-col>
        </b-row>
      </b-container>
      <!-- <b-modal title="新增品項" id="addCropModal" @hidden="hideModal" @ok="addProcess"> -->
      <b-modal
        size="lg"
        body-class="bmodal-body"
        v-model="modalshow"
        title="新增品項"
        id="addCropModal"
        hide-backdrop
        @hidden="hideModal"
        @ok="addProcess"
      >
        <!-- <b-form-group
                    label="*請選擇農情作物"
                    label-for="foodselect"
                    label-cols-sm="3"
                    label-align-sm="right"
                    >
                    <v-select id="foodselect" v-model="fruit.selectlist[0]" :options="fruit.typeoptionslist" @input="typeChoose"></v-select>
                </b-form-group> -->
        <b-form-group
          label="*請選擇市場作物"
          label-for="marketselect"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <v-select
            id="marketselect"
            v-model="fruit.selected"
            :options="pasrseToOptions(cropcodelist)"
            height="200px"
            :dense="true"
          ></v-select>
        </b-form-group>
        <!-- <b-form-group
          label="請選擇規格"
          label-for="specselect"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <template v-if="fruit.specSwitch">
            <v-select
              id="specselect"
              v-model="fruit.specSelected"
              :options="fruit.specList"
              height="200px"
              :dense="true"
              style="display: inline-block; width: 60%; padding-right: 0.5rem;"
            ></v-select>
            <b-button variant="primary" @click="inputSwitch">自行輸入</b-button>
          </template>
          <template v-else>
            <b-form-input id="specselect" style="display: inline-block; width: 59%; margin-right: 0.5rem;" v-model="fruit.specInput" placeholder="請輸入規格"></b-form-input>
            <b-button variant="warning" @click="inputSwitch">清單選擇</b-button>
          </template>
          
        </b-form-group> -->
        <template #modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="success" @click="ok()">
            儲存
          </b-button>
          <b-button size="sm" variant="warning" @click="cancel()">
            取消
          </b-button>
        </template>
      </b-modal>
    </div>
  </b-container>
</template>
<script>
import draggable from "vuedraggable";
import CROPCODELIST from "@/data/CROP_CODE_LIST.json";
import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var taiwanMaxDate = today
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      num: 10,
      perPage: 5,
      id: this.$route.params.id,
      counter: 0,
      total: 0,
      date: null,
      currentPage: 1,
      editlist: [],
      sortBy: "CM_SORT",
      modalshow: false,
      ifSorting: false,
      today: taiwanMaxDate.join("-"),
      maxdate: today
        .toLocaleString()
        .split(" ")[0]
        .split("/")
        .join("-"),
      // today: today.toLocaleString().split(' ')[0].split('/').join('-'),
      // maxdate: today.toLocaleString().split(' ')[0].split('/').join('-'),
      filterSearch: null,
      ifshowdelete: false,
      selection: [],
      totalRows: 1,
      Token: null,
      TokenID:
        "4ImX7kJFJSGhLW14LiAP8bbfW7lpO8pvW8uZqIXhFvlhTVhwF4nXhrWjn7NatmmqGrFiKJTOaA40KO+eN0G6pQ==",
      cropcodelist: CROPCODELIST,
      isBusy: true,
      // timepicker: {
      //     minvalue: '2021-06-17',
      //     maxvalue: '2021-06-24',
      //     min: minDate,
      //     max: maxDate,
      // },
      window: {
        width: 1024,
        height: 0,
      },
      
      removeobj: {},
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
        maintain_show: false,
        maintain_edit: false
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "農產品價格維護",
          href: "#/databuild",
        },
        {
          text: this.$route.params.id == "add" ? "新增" : "編輯",
          active: true,
        },
      ],
      priceanalysis: {
        fields: [
          {
            key: "CM_CODE",
            label: "品項",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "CROP_SPEC",
          //   label: "規格",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
          {
            key: "CM_PRICE_C",
            label: "上價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_M",
            label: "中價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_F",
            label: "下價",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_PRICE_MON",
            label: "農糧署產地價格監控 (元/公斤)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_QUEST",
            label: "詢問單位",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "CM_NOTES",
            label: "備註及說明",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: this.ifshowdelete,
          },
        ],
        items: [
        ],
        allitems: [
          {
            CM_DATE: "2021-06-24",
            CM_CODE: "香蕉",
            C_TYPE: "001",
            T_PRICE_MAX: "29.3",
            T_PRICE_MID: "21.9",
            T_PRICE_MIN: "15.9",
            CM_PRICE_C: "10",
            CM_PRICE_M: "5",
            CM_PRICE_F: "2",
            CM_PRICE_MON: "6.6",
            CM_QUEST: "中埔農會劉博嘉 嘉竹合作社 2532201#706",
            CM_NOTES: "",
          },
          {
            CM_DATE: "2021-06-24",
            CM_CODE: "鳳梨",
            C_TYPE: "002",
            T_PRICE_MAX: "46.9",
            T_PRICE_MID: "29.6",
            T_PRICE_MIN: "17.6",
            CM_PRICE_C: "55",
            CM_PRICE_M: "35",
            CM_PRICE_F: "15",
            CM_PRICE_MON: "8.1",
            CM_QUEST: "億鑫果菜運銷合作社 簡小姐 0978-070882 05-2950985",
            CM_NOTES: "打貓生產合作社",
          },
          {
            CM_DATE: "2021-06-24",
            CM_CODE: "木瓜",
            C_TYPE: "003",
            T_PRICE_MAX: "36.5",
            T_PRICE_MID: "29",
            T_PRICE_MIN: "19.6",
            CM_PRICE_C: "22.91",
            CM_PRICE_M: "18.75",
            CM_PRICE_F: "14.58",
            CM_PRICE_MON: "13.3",
            CM_QUEST: "中埔陳班長永明 0928-676193 中埔農會劉博嘉 2532201#706",
            CM_NOTES: "陳永明",
          },
          {
            CM_DATE: "2021-06-23",
            CM_CODE: "香蕉",
            C_TYPE: "001",
            T_PRICE_MAX: "29.3",
            T_PRICE_MID: "21.9",
            T_PRICE_MIN: "15.9",
            CM_PRICE_C: "10",
            CM_PRICE_M: "5",
            CM_PRICE_F: "2",
            CM_PRICE_MON: "6.6",
            CM_QUEST: "中埔農會劉博嘉 嘉竹合作社 2532201#706",
            CM_NOTES: "",
          },
          {
            CM_DATE: "2021-06-23",
            CM_CODE: "鳳梨",
            C_TYPE: "002",
            T_PRICE_MAX: "46.9",
            T_PRICE_MID: "29.6",
            T_PRICE_MIN: "17.6",
            CM_PRICE_C: "55",
            CM_PRICE_M: "35",
            CM_PRICE_F: "15",
            CM_PRICE_MON: "8.1",
            CM_QUEST: "億鑫果菜運銷合作社 簡小姐 0978-070882 05-2950985",
            CM_NOTES: "打貓生產合作社",
          },
          {
            CM_DATE: "2021-06-23",
            CM_CODE: "木瓜",
            C_TYPE: "003",
            T_PRICE_MAX: "36.5",
            T_PRICE_MID: "29",
            T_PRICE_MIN: "19.6",
            CM_PRICE_C: "22.91",
            CM_PRICE_M: "18.75",
            CM_PRICE_F: "14.58",
            CM_PRICE_MON: "13.3",
            CM_QUEST: "中埔陳班長永明 0928-676193 中埔農會劉博嘉 2532201#706",
            CM_NOTES: "陳永明",
          },
        ],
        additem: {},
        removelist: [],
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      fruit: {
        selectlist: [null, null],
        typeoptionslist: [
          { label: "請選擇", code: null, disabled: true },
          { label: "香蕉", code: 0 },
          { label: "鳳梨", code: 1 },
          { label: "木瓜", code: 2 },
        ],
        fruitlist: [
          {
            type: "香蕉",
            list: [
              { label: "請選擇", code: null },
              { label: "香蕉", code: "001" },
            ],
          },
          {
            type: "鳳梨",
            list: [
              { label: "請選擇", code: null },
              { label: "金鑽鳳梨", code: "002" },
            ],
          },
          {
            type: "木瓜",
            list: [
              { label: "請選擇", code: null },
              { label: "網室紅肉", code: "003" },
            ],
          },
        ],
        fruitoptions: [
          { text: "", value: "001" },
          { text: "金鑽鳳梨", value: "002" },
          { text: "網室紅肉", value: "003" },
        ],
        selected: [],
        specSwitch: true,
        specList: [],
        specSelected: null,
        specInput: null,
        options: ["全部", "香蕉", "鳳梨 金鑽鳳梨", "木瓜 網室紅肉"],
        options2: [],
        value: "全部",
        ifprocess: false,
      },
      apiGetTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/getTradeWarningCrop", data),
      apiUpdateTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/updateTradeWarningCrop", data),
      apiInsertCropManagement: (data) =>
        this.userRequest.post("/API/Default/InsertCropManagement", data),
      apigetCropManagement: (data) =>
        this.userRequest.post("/API/Default/getCropManagement", data),
      apiUpdateCropManagement: (data) =>
        this.userRequest.post("/API/Default/UpdateCropManagement", data),
      apiToken: (data) => this.userRequest.post("/API/Default/Token", data),
      apiCropSpecList: (data) =>
        this.userRequest.post("/API/Default/CropSpecList", data),
    };
  },
  components: {
    draggable,
    datepicker,
  },
  created() {
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();
    // this.init()
    this.checkLogin();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    //this.checkLogin();
    // this.checkPermission()
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000007",
        fun: this.checkByPJID,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000009",
        fun: this.checkByPJIDdelete,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000030",
        fun: this.checkByPJIMaintainShow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000031",
        fun: this.checkByPJIMaintainEdit,
      });
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      }
    },
    checkByPJIDdelete(value) {
      if (value) this.ifshowdelete = true;
      else this.ifshowdelete = false;
    },
    checkByPJIMaintainShow(value) {
      if (value) this.datamanagement.maintain_show = true;
    },
    checkByPJIMaintainEdit(value) {
      if (value) this.datamanagement.maintain_edit = true;
    },
    inputSwitch() {
      this.fruit.specSwitch = !this.fruit.specSwitch
      if(this.fruit.specSwitch) {
        this.fruit.specInput = null
      }
      else{
        this.fruit.specSelected = null
        
      } 
    },
    insertCropManagement(data) {
      this.apiInsertCropManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone2();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    insertCropManagementlist(data) {
      this.apiInsertCropManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCropManagement(data) {
      this.apigetCropManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            let list = [];
            for (let g in jsonData) {
              let subitem = jsonData[g];
              subitem["ifshow"] = false;
              if (subitem.CM_ISDEL == 0) {
                list.push(subitem);
              }
            }
            this.priceanalysis.items = JSON.parse(JSON.stringify(list));
            this.priceanalysis.items.sort((a, b) => {
              let y = (a.CM_SORT > b.CM_SORT) - (a.CM_SORT < b.CM_SORT);
              return y;
            });
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getCropList(data) {
      this.apiCropSpecList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let data = JSON.parse(json.Data)
            // console.log(data)
            this.fruit.specList = []
            data.forEach((x) => {
              // console.log(x.CROP_SPEC)
              let option = { label: x.CROP_SPEC, code: x.CROP_SPEC }
              this.fruit.specList.push(option)
            })
            this.fruit.specList.unshift({ label: "請選擇", code: null, disabled: true })
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getToken() {
      this.apiToken({})
        .then((res) => {
          if (!this.ifprocess) {
            this.ifprocess = true;
            this.Token = res.data;
            this.savelist();
          }
        })
        .catch((error) => {
          alert("發生錯誤!" + error);
        });
    },
    getToken2() {
      this.apiToken({})
        .then((res) => {
          this.Token = res.data;
          let obj = this.removeobj;
          obj["CM_ISDEL"] = 1;
          // obj['TokenID'] = this.TokenID
          obj["Token"] = this.Token;
          obj["Page"] = this.page;
          this.FunctionToken(this.removeCropManagement, [obj]);
        })
        .catch((error) => {
          alert("發生錯誤!" + error);
        });
    },
    updateCropManagement(data) {
      this.apiUpdateCropManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone2();
            // this.suceessPopUp("儲存成功")
            // this.$router.push({path: '/databuild'})
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //  checkLogin() {
    //     let TokenID = sessionStorage.getItem("TokenID");
    //     if(TokenID){
    //         this.checkPermission()
    //     }
    //     else
    //     {
    //         alert("無權限檢視此頁面，請登入帳號")
    //         this.$router.push({ path: '/login' })
    //     }
    // },
    init() {
      this.date = this.id == "add" ? this.today : this.id;
      let localmintime = this.date.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let obj = {
        CM_DATE: localmintime.join("-"),
      };
      // this.date = this.id=='add'?this.today:this.id
      // let obj={
      //     CM_DATE: this.date
      // }
      this.FunctionToken(this.getCropManagement, obj);
      this.FunctionToken(this.getCropList, {})
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    onEnd() {
      for (let j in this.priceanalysis.items) {
        let item1 = this.priceanalysis.items[j];
        item1["CM_SORT"] = parseInt(j) + 1;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    removeProcess(item) {
      if (confirm("確定要刪除品項?")) {
        if (this.IsNull(item["CM_ID"]) != "") {
          this.priceanalysis.removelist.push(item);
        }
        let index = this.priceanalysis.items.findIndex(
          (y) => y.CM_CODE == item.CM_CODE
        );
        this.priceanalysis.items.splice(index, 1);
        let count = 1;
        for(let j in this.priceanalysis.items){
          this.priceanalysis.items[j].CM_SORT = count;
          count++;
        }
      }
    },
    removeCropManagement(data) {
      this.apiUpdateCropManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let index = this.priceanalysis.items.findIndex(
              (y) => y.CM_CODE == this.removeobj
            );
            this.priceanalysis.items.splice(index, 1);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    pasrseToOptions(list1) {
      let list2 = [];
      for (let i in list1) {
        let item1 = list1[i];
        let obj = {
          label: item1.CROP,
          code: item1.CROP_CODE,
        };
        list2.push(obj);
      }
      return list2;
    },
    getName(code) {
      let index = this.cropcodelist.findIndex((y) => y.CROP_CODE == code);
      return this.cropcodelist[index].CROP;
    },
    savelist() {
      this.isBusy = true;
      this.counter = 0;
      this.total = 0;
      this.editlist = [];
      let datelist1 = [];
      if (this.priceanalysis.items.length != 0) {
        let count = 0;
        datelist1 = this.priceanalysis.items[0].CM_DATE.split("-");
        let datelist2 = this.date.split("-");
        datelist2[0] = parseInt(datelist2[0]) + 1911;
        if (datelist2[1].length == 1 && datelist1[1].charAt(0) == "0") {
          datelist1[1] = datelist1[1].charAt(1);
        }
        if (datelist2[2].length == 1 && datelist1[2].charAt(0) == "0") {
          datelist1[2] = datelist1[2].charAt(1);
        }
        for (let k in datelist1) {
          if (datelist1[k] == datelist2[k]) {
            count++;
          }
        }
        if (count == 3) {
          for (let j in this.priceanalysis.items) {
            let item1 = this.priceanalysis.items[j];
            let index1 = this.cropcodelist.findIndex(
              (x) => x.CROP_CODE == item1.CM_CODE
            );
            let subitem = this.cropcodelist[index1];
            let obj = item1;
            obj["CROP_NAME"] = subitem.CROP;
            obj["CM_SORT"] = parseInt(j) + 1;
            obj["CM_ISDEL"] = 0;
            obj["CM_PRICE_C"] = parseFloat(item1.CM_PRICE_C);
            obj["CM_PRICE_M"] = parseFloat(item1.CM_PRICE_M);
            obj["CM_PRICE_F"] = parseFloat(item1.CM_PRICE_F);
            obj["CM_PRICE_MON"] = parseFloat(item1.CM_PRICE_MON);
            obj["CM_DATE"] = datelist2.join("-");
            // obj['TokenID'] = this.TokenID
            obj["Token"] = this.Token;
            obj["Page"] = this.page;
            if (this.IsNull(obj["CM_ID"]) == "") {
              this.total++;
              this.FunctionToken(this.insertCropManagement, obj);
            } else if (this.IsNull(obj["CM_ID"]) != "") {
              this.editlist.push(obj);
            }
          }
          if (this.editlist.length != 0) {
            this.total++;
            this.FunctionToken(this.updateCropManagement, this.editlist);
          }
        } else if (count != 3) {
          for (let j in this.priceanalysis.items) {
            let item1 = this.priceanalysis.items[j];
            let index1 = this.cropcodelist.findIndex(
              (x) => x.CROP_CODE == item1.CM_CODE
            );
            
            let subitem = this.cropcodelist[index1];
            let obj = item1;
            obj["CM_ID"] = "";
            obj["CROP_NAME"] = subitem.CROP;
            obj["CM_DATE"] = datelist2.join("-");
            obj["CM_PRICE_C"] = parseFloat(item1.CM_PRICE_C);
            obj["CM_PRICE_M"] = parseFloat(item1.CM_PRICE_M);
            obj["CM_PRICE_F"] = parseFloat(item1.CM_PRICE_F);
            obj["CM_PRICE_MON"] = parseFloat(item1.CM_PRICE_MON);
            obj["CM_SORT"] = parseInt(j) + 1;
            obj["CM_ISDEL"] = 0;
            // obj['TokenID'] = this.TokenID
            obj["Token"] = this.Token;
            obj["Page"] = this.page;
            this.total++;
            this.FunctionToken(this.insertCropManagement, obj);
          }
        }
      }
      if (this.priceanalysis.removelist.length != 0) {
        let list2 = [];
        for (let k in this.priceanalysis.removelist) {
          let item2 = this.priceanalysis.removelist[k];
          let obj = item2;
          obj["CM_ISDEL"] = 1;
          // obj['TokenID'] = this.TokenID
          obj["Token"] = this.Token;
          obj["Page"] = this.page;
          list2.push(obj);
        }
        this.total++;
        this.FunctionToken(this.updateCropManagement, list2);
      }
    },
    checkIfdone() {
      let num = this.priceanalysis.items.length;
      if (this.counter == num) {
        this.suceessPopUp("儲存成功");
        this.isBusy = false;
        this.$router.push({ path: "/databuild" });
      }
    },
    checkIfdone2() {
      if (this.counter == this.total) {
        this.suceessPopUp("儲存成功");
        this.isBusy = false;
        this.$router.push({ path: "/databuild" });
      }
    },
    datechange() {
      let localmintime = this.date.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let obj = {
        CM_DATE: localmintime.join("-"),
      };
      this.FunctionToken(this.getCropManagement, obj);
    },
    unitTransfer(value, index, index2) {
      if (index == 0) {
        if (index2 == 0)
          value.AM_PRICE_L_TW = Math.round(value.AM_PRICE_L * 0.6 * 100) / 100;
        else if (index2 == 1)
          value.AM_PRICE_R_TW = Math.round(value.AM_PRICE_R * 0.6 * 100) / 100;
      } else if (index == 1) {
        if (index2 == 0)
          value.AM_PRICE_L = Math.round(value.AM_PRICE_L_TW * 1.67 * 100) / 100;
        else if (index2 == 1)
          value.AM_PRICE_R = Math.round(value.AM_PRICE_R_TW * 1.67 * 100) / 100;
      }
    },
    // async checkPermission() {
    //   let accountdata = { PJ_ID: "PJ000000000014", fun: this.checkshowByPJID };
    //   this.FunctionToken(this.Authority, accountdata);
    //   let databuilddata = {
    //     PJ_ID: "PJ000000000015",
    //     fun: this.checkeditdataByPJID,
    //   };
    //   this.FunctionToken(this.Authority, databuilddata);
    // },
    // checkshowByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.datamanagement.ifshow = false;
    //     this.$router.push({ path: "/" });
    //   } else {
    //     this.datamanagement.ifshow = true;
    //     this.FunctionToken(this.getTradeWarningCrop, {});
    //   }
    // },
    // checkeditdataByPJID(value) {
    //   if (!value) {
    //     this.datamanagement.ifedit = false;
    //   } else {
    //     this.datamanagement.ifedit = true;
    //   }
    // },
    checksave(item) {
      if (this.IsNull(item.TC_LIMIT)) {
        this.priceanalysis.additem = item;
        this.$bvModal.show("savemodal");
      }
    },
    hideModal() {
      this.priceanalysis.additem = {};
      this.$bvModal.hide("addCropModal");
    },
    addProcess() {
      if (this.IsNull(this.fruit.selected) == "") {
        alert("請選擇作物");
      } 
      // else if(this.fruit.specSelected == null && this.fruit.specInput == null ) {
      //   alert("請選擇規格或是輸入規格");
      // }
      else if (
        this.priceanalysis.items.findIndex(
          (x) => x.CM_CODE == this.fruit.selected.code
        ) != -1
      ) {
        alert("此品項已存在");
      } 
      else {
        this.isBusy = true;
        // let specObject = this.fruit.specSelected != null ? this.fruit.specSelected.code : this.fruit.specInput != null ? this.fruit.specInput : null
        let obj = {
          CM_DATE: this.date,
          CM_CODE: this.fruit.selected.code,
          // CROP_SPEC: specObject,
          CROP_NAME: this.fruit.selected.label,
          CM_SORT: this.priceanalysis.items.length+1,
          // C_TYPE: this.fruit.selectlist[1],
          // T_PRICE_MAX: '',
          // T_PRICE_MID: '',
          // T_PRICE_MIN: '',
          CM_PRICE_C: "",
          CM_PRICE_M: "",
          CM_PRICE_F: "",
          CM_PRICE_MON: "",
          CM_QUEST: "",
          CM_NOTES: "",
          ifshow: false,
          // ifedit: false
        };
        // console.log(obj)
        this.priceanalysis.items.push(obj);
        // this.FunctionToken(this.insertCropManagement, obj)
      }
    },
    // fruitChoose() {
    // },
    typeChoose(index) {
      this.fruit.selectlist[1] = null;
      this.fruit.options2 = this.fruit.fruitlist[index.code].list;
    },
    saveProcess() {
      let obj = {
        TC_ID: this.priceanalysis.additem.TC_ID,
        TC_LIMIT: this.priceanalysis.additem.TC_LIMIT,
      };
      this.FunctionToken(this.updateTradeWarningCrop, obj);
    },
    updateTradeWarningCrop(data) {
      this.apiUpdateTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.suceessPopUp("儲存成功");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getTradeWarningCrop(data) {
      this.apiGetTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.priceanalysis.items = jsonData;
            this.addcount();
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
  },
  computed: {
    visibleFields() {
      return this.priceanalysis.fields.filter((field) => field.visible);
    },
  },
  // watch: {
  //     'priceanalysis.items'()
  //     {
  //         this.settotalRows()
  //     }
  // }
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
</style>
